import React from 'react';
import {Menu, Breadcrumb} from 'semantic-ui-react';
import _ from 'lodash';

export const PanelReviewTopNav = ({
  organizationName,
  section,
  entityAlias,
  entityDisplay,
  sessionId,
}) => {
  return (
    <div>
      <Menu id="topNav" fixed="top" size="large" fluid borderless>
        <Menu.Item>
          <Breadcrumb size="large">
            <Breadcrumb.Section href={`/panelReview/sessions/${sessionId}/tasks`}>
              Dashboard
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>{organizationName}</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
        <Menu.Item position="right" style={{width: '300px'}}>
          <strong>{section}</strong>
        </Menu.Item>
        <Menu.Item position="right">
          <strong>{`${entityAlias}: ${entityDisplay}`}</strong>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default PanelReviewTopNav;
